import { render } from "./ResetPassword.vue?vue&type=template&id=2c352455&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=2c352455&scoped=true&lang=scss"
/* custom blocks */
import block0 from "@/locales/ru/views/reset-password.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FResetPassword.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/views/reset-password.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2FResetPassword.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c352455"]])

export default __exports__